import moment from "moment";

export const PAGE_SIZE =
  typeof window !== "undefined"
    ? Math.max(10, Math.floor((window.innerHeight - 200) / 48))
    : 20;

export const capitalizeFirstLetter = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const toTitleCase = (str) =>
  // Convert to title case
  str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });

export const formatDate = (dateString) => {
  // return moment(dateString).format("MMM DD, YYYY hh:mm A");
  return moment(dateString).format("YYYY/MM/DD hh:mm A");
};

export const sumArray = (arr) => {
  // console.log(arr);
  return arr.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
};

// One evaluation per chat session: the 평가 실행 buttons die once one exists. 6 chatlogs =
// 3 turns, the server's minimum. Shared by ChatSessionsList and ChatSessionPerform — both
// render this button, and only guarding one of them let the other run repeat evaluations.
export const canEvaluate = (cs) =>
  cs.chatlog_count >= 6 && cs.evaluation_session_count === 0;
